// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3xKXm","cell":"ColumnAccessor_cell__axJib","firstCellAccent":"ColumnAccessor_firstCellAccent__1BVuH"};